export function toFixedTrunc(x: number, n: number): number {
    const v = (typeof x === 'string' ? x : x.toString()).split('.');
    if (n <= 0) { return +(v[0]); }
    let f = v[1] || '';
    if (f.length > n) { return +(`${v[0]}.${f.substr(0, n)}`); }
    while (f.length < n) { f += '0'; }
    return +(`${v[0]}.${f}`);
}
